type TIsEmptyObject = (v: Record<string, unknown>) => boolean;

export const isEmptyObject: TIsEmptyObject = (obj) => !Object.keys(obj).length;
